// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block-editor-block-types-list > [role="presentation"] {
	overflow: hidden;
	display: flex;
	flex-wrap: wrap;
}
`, "",{"version":3,"sources":["webpack://./assets/jsx/workflow-editor/css/block-types-list.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,aAAa;CACb,eAAe;AAChB","sourcesContent":[".block-editor-block-types-list > [role=\"presentation\"] {\n\toverflow: hidden;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
